/**
 * ТЗ №1 §3.3: user-facing названия уровней иерархии.
 * Backend/internal идентификаторы (factory/workshop/section/room, route'ы,
 * ключи state) НЕ переименовываются — только видимые пользователю подписи.
 *
 *   one        — единственное число, именительный («Объект»)
 *   plural     — множественное, именительный («Объекты»)
 *   all        — placeholder фильтра («Все объекты»)
 *   accusative — винительный для «Создать …» / «Выберите …» («объект»)
 *   genitivePlural — родительный мн. для «Кол-во …» («объектов»)
 */
export const HIERARCHY_LABELS = {
  factory: { one: 'Объект', plural: 'Объекты', all: 'Все объекты', accusative: 'объект', genitivePlural: 'объектов' },
  workshop: { one: 'Подразделение', plural: 'Подразделения', all: 'Все подразделения', accusative: 'подразделение', genitivePlural: 'подразделений' },
  section: { one: 'Область', plural: 'Области', all: 'Все области', accusative: 'область', genitivePlural: 'областей' },
  room: { one: 'Локация', plural: 'Локации', all: 'Все локации', accusative: 'локацию', genitivePlural: 'локаций' },
  camera: { one: 'Камера', plural: 'Камеры', all: 'Все камеры', accusative: 'камеру', genitivePlural: 'камер' },
};

/** polygon / zone → «Зона контроля»; zone_id/zones/monitoring_zone не трогаем. */
export const ZONE_LABEL = 'Зона контроля';
export const ZONE_LABEL_PLURAL = 'Зоны контроля';

/** «Камера C110»; имя, которое уже начинается со слова «Камера», не дублируется. */
export const withCameraWord = (name) => (/^камера/i.test(String(name || '').trim()) ? name : `Камера ${name}`);
